export default {
  header: {
    title: 'Code promo ou carte cadeau',
  },
  available_codes: {
    title_one: 'Code disponible ({{count}})',
    title_other: 'Codes disponibles ({{count}})',
    min_threshold: 'Min. {{value}}',
    percentage_off: '{{discount}}% de réduction sur cette commande',
    amount_off: '{{amount}} de réduction sur cette commande',
  },
  content: {
    input: {
      placeholder: 'Entrez un code',
    },
    buttons: {
      done: 'Terminé',
      apply: 'Appliquer',
      applied: 'Appliqué ✓',
    },
  },
};
